var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import CircularProgress from '@/components/CircularProgress.vue';
let SurveyDetails = class SurveyDetails extends Vue {
    constructor() {
        super(...arguments);
        this.depDetails = {};
    }
    closeDetails() {
        return { id: '', open: false };
    }
    setDetails() {
        this.depDetails = this.details[0];
    }
};
__decorate([
    Prop({ default: false })
], SurveyDetails.prototype, "openDetail", void 0);
__decorate([
    Prop({ default: false })
], SurveyDetails.prototype, "showInvalidate", void 0);
__decorate([
    Prop({ default: {} })
], SurveyDetails.prototype, "details", void 0);
__decorate([
    Prop({ default: '' })
], SurveyDetails.prototype, "initialsName", void 0);
__decorate([
    Emit('closeDetails')
], SurveyDetails.prototype, "closeDetails", null);
__decorate([
    Watch('details')
], SurveyDetails.prototype, "setDetails", null);
SurveyDetails = __decorate([
    Component({
        name: 'SurveyDetails',
        components: { CircularProgress },
    })
], SurveyDetails);
export default SurveyDetails;
